// The bell's list: agents paused on a question, and devices waiting to be approved.
import { Link } from "react-router";
import { Dropdown } from "rizzui";

import { useT } from "../i18n";
import { ago } from "../pages/format";
import type { Attention } from "./attention";

const row = "block w-full rounded-none border-b border-muted px-4 py-3 text-start last:border-0 hover:bg-gray-50 dark:hover:bg-gray-200/40";

export function NotificationsPanel({ attention }: { attention: Attention }) {
  const t = useT().shell.notifications;
  const { questions, pendingDevices } = attention;
  return (
    <div>
      <div className="border-b border-muted px-4 py-3">
        <div className="font-display text-sm font-bold text-gray-900">{t.title}</div>
        <div className="text-xs text-gray-500">{t.subtitle}</div>
      </div>
      {questions.length === 0 && pendingDevices.length === 0 ? (
        <div className="px-4 py-5 text-[13px] text-gray-500">{t.empty}</div>
      ) : null}
      {questions.map((q) => (
        <Dropdown.Item key={q.question_id} as="li" className="!p-0">
          <Link to={`/runs/${q.run_id}`} className={row}>
            <span className="block text-[13px] font-semibold text-gray-900">{t.asked(q.workflow_name ?? t.aRun)}</span>
            <span className="block text-xs text-gray-500">{t.encrypted(ago(q.asked_at))}</span>
          </Link>
        </Dropdown.Item>
      ))}
      {pendingDevices.map((d) => (
        <Dropdown.Item key={d.id} as="li" className="!p-0">
          <Link to="/devices" className={row}>
            <span className="block text-[13px] font-semibold text-gray-900">{t.wantsToLink(d.name)}</span>
            <span className="block text-xs text-gray-500">{t.checkFingerprint}</span>
          </Link>
        </Dropdown.Item>
      ))}
    </div>
  );
}
